module.exports = __webpack_public_path__ + "img/clubroom_btn.998cc2d7.png";